// RoutesComponent.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/Login';
import CreatorMainMenu from './components/CreatorMainMenu';
import AdminMainMenu from './components/AdminMainMenu';
import UserMainMenu from './components/UserMainMenu';
import GenerateAdminToken from './components/GenerateAdminToken';
import GenerateUserToken from './components/GenerateUserToken';
import Register from './components/Register';
import Combined2FA from './components/Combined2FA';
import Footer from './components/Footer';
import Report from './components/Report';


const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    // Allow access to 2FA routes even without a full token
    if (location.pathname === '/enable-2fa' || location.pathname === '/verify-2fa') {
      return children;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};


const RoutesComponent = () => {
  const role = useSelector((state) => state.user.role);

  const getMenuComponent = () => {
    if (role === 'creator') {
      return <CreatorMainMenu />;
    } else if (role === 'admin') {
      return <AdminMainMenu />;
    } else {
      return <UserMainMenu />;
    }
  };

  return (
    <BrowserRouter>
      <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" 
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute>{getMenuComponent()}</ProtectedRoute>} />
        {role === 'creator' && (
          <Route path="/generate-admin-token" element={<ProtectedRoute><GenerateAdminToken /></ProtectedRoute>} />
        )}
        {role === 'admin' && (
          <Route path="/generate-user-token" element={<ProtectedRoute><GenerateUserToken /></ProtectedRoute>} />
        )}
        <Route path="/register" element={<Register />} />
        <Route path="/enable-2fa" element={<ProtectedRoute><Combined2FA /></ProtectedRoute>} />
        <Route path="/verify-2fa" element={<ProtectedRoute><Combined2FA /></ProtectedRoute>} />
        <Route path="/report" element={<ProtectedRoute><Report /></ProtectedRoute> } />
        
        {/* <Route path="/enable-2fa" element={<Combined2FA />} />
        <Route path="/verify-2fa" element={<Combined2FA />} /> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default RoutesComponent;
